import { sbaAxios } from "../utils/sbaAxios";
import { getMarketDataIndices,getMarketDataDetail } from "../../config/apiConfig";
import {
    FETCH_MARKETDATA_BEGIN,
    FETCH_MARKETDATA_SUCCESS,
    FETCH_MARKETDATA_FAILURE,

    FETCH_MARKETDATADETAILS_BEGIN,
    FETCH_MARKETDATADETAILS_SUCCESS,
    FETCH_MARKETDATADETAILS_FAILURE,
} from '../constants/marketdata';
import { updateEntity } from "../CommonAPI";

export const getAllMarketDataIndices = (searchtxt) => {
    return (dispatch) => {
        dispatch(fetchMarketDataIndicesBegin());
        sbaAxios({
            url: `${getMarketDataIndices}?searchtxt=${searchtxt}`,
            method: 'get',
        })
            .then((repos) => {
                const Indices = repos;
                dispatch(fetchMarketDataIndicesSuccess(Indices));
                return Indices;
            })
            .catch((error) => dispatch(fetchMarketDataIndicesFailure(error)));
    };
}

export const fetchMarketDataIndicesBegin = () => ({
    type: FETCH_MARKETDATA_BEGIN,
});

export const fetchMarketDataIndicesSuccess = (Indices) => ({
    type: FETCH_MARKETDATA_SUCCESS,
    payload: { Indices },
});


export const fetchMarketDataIndicesFailure = (errorMessage) => ({
    type: FETCH_MARKETDATA_FAILURE,
    payload: { errorMessage }
});



export const getMarketDataDetails = (marketIndexId) => {
    return (dispatch) => {
        dispatch(fetchMarketDatadetailBegin());
        sbaAxios({
            url: `${getMarketDataDetail}${marketIndexId}`,
            method: 'get',
        })
            .then((repos) => {
                const details = repos;
                dispatch(fetchMarketDatadetailSuccess(details));
                updateEntity("MarketdataId",marketIndexId);
                return details;
            })
            .catch((error) => dispatch(fetchMarketDatadetailFailure(error)));
    };
}

export const fetchMarketDatadetailBegin = () => ({
    type: FETCH_MARKETDATADETAILS_BEGIN,
});

export const fetchMarketDatadetailSuccess = (Marketdatadetails) => ({
    type: FETCH_MARKETDATADETAILS_SUCCESS,
    payload: {Marketdatadetails},
});


export const fetchMarketDatadetailFailure = (errorMessage) => ({
    type: FETCH_MARKETDATADETAILS_FAILURE,
    payload: { errorMessage }
});

